const stripHtml = (html = "") =>
  html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();

export const normalizePolicies = (policyList) => {
  const chunks = [];

  policyList.forEach(policy => {
    policy.policyDetailsList.forEach(p => {
      chunks.push({
        id: `${policy.Id}-${p.Id}`,
        text: `Policy: ${policy.PolicyName}
Section: ${p.ParagraphHeader}
${stripHtml(p.ParagraphDescription)}`
      });
    });
  });

  console.log("📝 Chunks from API:", chunks.length);
  return chunks;
};